<template>
  <div id="app">
    <Loader
      v-if="!isUserAuthenticated || loading"
    >
    </Loader>
    <template
       v-else
    >
      <Header />
      <main role="main">
        <router-view/>
      </main>
      <Notifications />
      <ConnectionMethodBadge />
    </template>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Header from '@/partials/site-structure/HeaderComponent.vue'
import Notifications from '@/partials/site-structure/NotificationsComponent.vue'
import ConnectionMethodBadge from '@/components/ConnectionMethodBadge.vue'
import Loader from '../../Common/components/Loader.vue'
import GeneralErrorModal from '@/components/modals/GeneralErrorModalComponent.vue'
// import axios from 'axios'
export default {
  name: 'App',

  components: {
    Header,
    Loader,
    Notifications,
    ConnectionMethodBadge
  },

  data() {
    return {
      loading: true
    }
  },

  watch: {
    isUserAuthenticated: async function(val) {
      if(val == true) {
        await this.initApp()
        const lastUrlAtLogin = localStorage.getItem("lastUrlAtLogin")
        if(lastUrlAtLogin != null && lastUrlAtLogin !== process.env.VUE_APP_MSAL_REDIRECT_URI) {
          this.$router.push({path: lastUrlAtLogin})
        }
        localStorage.removeItem("lastUrlAtLogin")
      }
    }
  },

  async mounted() {
    await this.$msal.signIn()
  },

  computed: {
    ...mapGetters({
      isUserAuthenticated: 'UserStore/GetIsUserAuthenticated',
      organisationId: 'UserStore/GetUserOrganisationId'
    })
  }, 

  methods: {
    ...mapActions({
      getOrganisationSettingsMap: 'OrganisationStore/GetOrganisationSettingsMap',
      getMyOrganisation: 'OrganisationStore/GetMyOrganisation',
      getMyOrganisationSettings: 'OrganisationStore/GetMyOrganisationSettings',
      getMyFacilities: 'FacilityStore/GetMyFacilities',
      getUserDetails: 'UserStore/GetPractitionerUserDetails',
      getEthnicities: 'EthnicityStore/GetEthnicities',
      setNotification: 'NotificationStore/SetNotification',
      setAppInitLoaded: 'UserStore/SetAppInitLoaded',
      signout: 'UserStore/Signout',
      populateLanguages: 'LanguageStore/PopulateLanguages'
    }),

    async initApp() {
      try {
        console.log(process.env.VUE_APP_VERSION)
        await this.getMyOrganisation()
        await this.getOrganisationSettingsMap()
        await this.getMyOrganisationSettings()
        await this.getUserDetails(this.organisationId)
        await this.getMyFacilities()
        await this.populateLanguages()
        await this.getEthnicities()

        this.setAppInitLoaded()
      }
      catch {
         this.$modal.show(GeneralErrorModal, { message: 'Services are currently down.' })
      }
      finally {
        this.loading = false
      }
    }
  }
}
</script>
